// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".get-prv-key-wrapper .el-row[data-v-4c8c307c]{margin:0 calc(0px - var(--base-size-16))}.get-prv-key-wrapper .el-row .el-col[data-v-4c8c307c]{padding:0 var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
